// Mixins
import Vue from 'vue';
import {GET_CUSTOMER_BY_SUB_BATCH} from "@/graphql/queries/Customers";
import {INSERT_FAILED_RETAIL_SALES, UPSERT_CUSTOMER_AND_INSERT_RETAIL_SALES} from "@/graphql/mutations/customer";
import Constant from "@/Constants/Constant";
import moment from "moment/moment";

/**
 * Retail Sales Entry
 * @mixin
 *
 * Used to add retail-sales entry functionality to components
 */

export default Vue.extend({
    name: 'retailSalesEntry',
    methods:{
        async addEntry(subBatch, from){
            /* -- Fetch Customer from ProductInventorySales table -- */
            let inventory = {};
            let res = await this.$apollo.query({
                query: GET_CUSTOMER_BY_SUB_BATCH,
                fetchPolicy: 'network-only',
                variables: { subBatch }
            });
            if(res.data.inv.length) inventory = res.data.inv[0]
            else return this.addFailedRetailSales(subBatch, from)

            /* ------------- Fetch Customer by Email ------------- */
            let customer = {name:'', email:'', companyName:'', orgId:from.orgId};
            Object.copyExistingKeys(customer, inventory);
           /* let res1 = await this.$apollo.query({
                query: CHECK_CUSTOMER_BY_EMAIL,
                fetchPolicy: 'network-only',
                variables: { email: inventory.email }
            });
            customer.id = res1.data.Customer[0]?.id || Constant.generateUUID(); */
            customer.id = Constant.generateUUID();

            /* ------- Upsert Customer & Retail Sales Entry ------- */
            let order = this.prepareOrder(inventory, customer, from);
            let orderItems = this.prepareOrderItems(inventory, customer, order)
            let res2 = await this.$apollo.mutate({
                mutation: UPSERT_CUSTOMER_AND_INSERT_RETAIL_SALES,
                variables: { order, orderItems, customer }
            })
           // if(res2.data) this.$q.notify(`Retail Sales Entry added Successfully for serial ${subBatch}`);
        },
        prepareOrder(inv, customer, from){
            return {
                id: Constant.generateUUID(),
                date: inv.activationDate || moment(),
                from: from.orgId, to: customer.id,
                lineItemCounts: 1, status: 'InTransit',
                placedBy: from.userId, orderType: 2
            }
        },
        prepareOrderItems(inv, customer, order) {
            return [{
                id: Constant.generateUUID(),
                orderId: order.id, qty: 1,
                from: order.from, to: customer.id,
                sellType: '2', status: 'Sold',
                batchId: inv.batchId, productInventoryId: inv.subBatchId,
                productId: inv.productId,
                meta: {
                    activationDate: inv.activationDate ? moment(inv.activationDate, 'YYYY-MM-DD').format('DD-MM-YYYY'): null,
                    productKey: inv.licenseKey, remark: '',
                    expiryDate: inv.expirationDate ? moment(inv.expirationDate, 'YYYY-MM-DD').format('DD-MM-YYYY'): null
                }
            }]
        },
        async addFailedRetailSales(serial, from){
            this.$q.notify(`No record found in ProductInventorySales with serial ${serial}`)
            await this.$apollo.mutate({
                mutation: INSERT_FAILED_RETAIL_SALES,
                variables: {
                    order: {serial, from:from.orgId}
                }
            })
        }
    }
});
